/**
 * When the signed-in profile is read again without a reload: the tab or
 * the installed app coming back to the front. `refresh` is the store's
 * throttled `refreshProfile`, so a burst of events (focus + visibility
 * fire together) costs one request at most. Returns the detach function.
 */
export function watchProfileRefresh(refresh, { doc = document, win = window } = {}) {
  const onVisibility = () => {
    if (doc.visibilityState === 'visible') void refresh()
  }
  const onFocus = () => void refresh()
  doc.addEventListener('visibilitychange', onVisibility)
  win.addEventListener('focus', onFocus)
  return () => {
    doc.removeEventListener('visibilitychange', onVisibility)
    win.removeEventListener('focus', onFocus)
  }
}
